// React
import React, { useEffect, useState } from "react";

// MUI Components
import {
  Dialog,
  Button,
  TextField,
  Box,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";

// Assets
import cross from "../../assets/close-circle.svg";

// Services
import { CategoryEntry } from "../../services/PublishcategoryEntryService";
import { getStorageItemLocal } from "../../services/storageServices";

// Config
import { appConfig } from "../../config/appConfig";

// Components
import Spinner from "../spinner/Spinner";

// Styles
import "./PublishCategoryFormDialog.scss";

interface PublishCategoryFormDialogProps {
  open: boolean;
  onClose?: () => void;

  fetchData: () => void;
  resetForm: () => void;

  formData: CategoryEntry;
  setFormData: any;
  editingIndex: any;
  setShowForm: any;
  setEditingIndex: any;
  dataList: any;
}

const PublishCategoryFormDialog: React.FC<PublishCategoryFormDialogProps> = ({
  open,
  onClose,
  fetchData,
  resetForm,

  formData,
  setFormData,
  editingIndex,
  setShowForm,
  setEditingIndex,
  dataList,
}) => {
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [selectedPin, setSelectedPin] = useState<File[]>([]);

  const [thumbnailpreview, setthumbnailpreview] = useState<string>("");
  const [pinpreview, setpinpreview] = useState<string>("");

  const [fileName, setfileName] = useState<string>("");
  const [fileName2, setfileName2] = useState<string>("");

  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const pinIconPath = Array.isArray(formData.pinIcon)
    ? formData.pinIcon[0]?.trim()
    : formData.pinIcon?.trim();

  const IconPath = Array.isArray(formData.icon)
    ? formData.icon[0]?.trim()
    : formData.icon?.trim();

  useEffect(() => {
    if (IconPath) {
      const extractedFileName = IconPath.split("/").pop()?.trim() ?? "";

      setfileName(extractedFileName);
    }
    if (pinIconPath) {
      const extractedFileName = pinIconPath.split("/").pop()?.trim() ?? "";

      setfileName2(extractedFileName);
    }
    setIsChecked(formData.isActive);
  }, [formData]);

  //Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      lastUpdated: new Date().toISOString(),
    });
  };

  //handle Image Upload
  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const filesArray = Array.from(files);
    setSelectedImages(filesArray);
    const file = files[0];
    setthumbnailpreview(URL.createObjectURL(file));
    setfileName(file.name);
  };

  //Radio Button
  const handleActive = () => {
    setIsChecked(!isChecked);
  };
  const handlePinUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const filesArray = Array.from(files);
    setSelectedPin(filesArray);
    const file = files[0];
    setpinpreview(URL.createObjectURL(file));
    setfileName2(file.name);
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      alert("Name is required!");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("id", editingIndex?.toString() ?? "0");
    formDataToSend.append("name", formData.name);

    formDataToSend.append("isActive", isChecked.toString());
    formDataToSend.append("status", "Approved"); //Approved  Pending for Approval

    const username = getStorageItemLocal("username") ?? "";
    formDataToSend.append("uploadBy", username);

    if (selectedImages.length > 0) {
      selectedImages.forEach((image) => {
        formDataToSend.append("icon", image);
      });
    } else if (formData.icon) {
      const icons = Array.isArray(formData.icon)
        ? formData.icon
        : [formData.icon];
      for (const url of icons) {
        const cleanUrl = typeof url === "string" ? url.trim() : "";
        if (cleanUrl && cleanUrl !== "null") {
          formDataToSend.append("icon", cleanUrl);
        }
      }
    }

    if (selectedPin.length > 0) {
      selectedPin.forEach((image) => {
        formDataToSend.append("pinIcon", image);
      });
    } else if (formData.pinIcon) {
      const pins = Array.isArray(formData.pinIcon)
        ? formData.pinIcon
        : [formData.pinIcon];
      for (const url of pins) {
        const cleanUrl = typeof url === "string" ? url.trim() : "";
        if (cleanUrl && cleanUrl !== "null") {
          formDataToSend.append("pinIcon", cleanUrl);
        }
      }
    }
    setLoading(true);
    const url =
      editingIndex !== null
        ? `${appConfig.serviceUrls.saveCategory}/${formData.id}`
        : `${appConfig.serviceUrls.saveCategory}/upload`;
    try {
      const response = await fetch(url, {
        method: editingIndex !== null ? "PUT" : "POST",
        body: formDataToSend,
      });
      if (!response.ok) throw new Error("Failed to save data");
      alert("Data saved successfully");
      fetchData();
      resetForm();
      const imgInput = document.getElementById("imageUpload") as HTMLInputElement | null;
      if (imgInput) imgInput.value = "";
      setSelectedImages([]);
      setEditingIndex(null);
      setShowForm(false);
    } catch (error) {
      console.error("Error saving data:", error);
    } finally {
      setLoading(false);
    }
    handleCancel();
  };
  const handleCancel = () => {
    onClose?.();
    setthumbnailpreview("");
    setpinpreview("");
    setSelectedImages([]);
    setSelectedPin([]);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "90%",
          height: "95%",
        },
      }}
    >
      {/* header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F7F7F7",
          padding: "15px 16px", // Optional: improves appearance
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // center the items vertically
            gap: 1, // adds spacing between icon and text
          }}
        >
          <Typography className="custom-icon-text">
            {editingIndex !== null ? "Edit Category" : "Add Category"}
          </Typography>
        </Box>
        <Box className="cross-btn">
          <IconButton
            color="primary"
            size="small"
            onClick={handleCancel}
            className="custom-icon-button2"
          >
            <img src={cross} alt="visible" className="custom-icon2" />
          </IconButton>
        </Box>
      </Box>

      {/* body //////////////////////*/}
      {loading ? (
        <>
          {" "}
          <Spinner></Spinner>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "flex-start",
            background: "#FFF",
            padding: "25px 16px",
          }}
        >
          {/* 1st box */}
          <Box>
            <TextField
              // disabled={editingIndex !== null}
              label="CategoryName"
              name="name"
              value={formData.name}
              onChange={handleChange}
              size="small"
              className="custom-select"
            ></TextField>
            <Box sx={{ paddingBottom: "35px" }} />

            <Typography>
              {" "}
              <b>Menu Icon </b>{" "}
            </Typography>
            <Box className="pdf-upload-row">
              <Box className="pdf-name-wrapper">
                <TextField
                  placeholder="Choose Icon"
                  size="small"
                  name="pdfName"
                  value={fileName}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
              </Box>

              <Box>
                <Button component="label" className="choose-pdf-button">
                  <Typography className="pdf-button-text ">Browse</Typography>
                  <input
                    id="pdfUpload"
                    type="file"
                    accept="image/jpeg,image/png*"
                    onChange={handleImageUpload}
                    hidden
                    //   onChange={handlePdfUpload}
                  />
                </Button>
                {/* {pdferror && <Alert severity="error">{pdferror}</Alert>} */}
              </Box>
            </Box>
            <Typography className="image-note">
              Note: The Menu Icon resolution should be 500 × 500 and should be
              in .png format.
            </Typography>
            {/* Pin Icon */}
            <Box sx={{ paddingBottom: "35px" }} />

            <Typography>
              {" "}
              <b>Map Pin </b>{" "}
            </Typography>
            <Box className="pdf-upload-row">
              <Box className="pdf-name-wrapper">
                <TextField
                  placeholder="Choose Map pin"
                  size="small"
                  name="pdfName"
                  value={fileName2}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
              </Box>

              <Box>
                <Button component="label" className="choose-pdf-button">
                  <Typography className="pdf-button-text ">Browse</Typography>
                  <input
                    id="pdfUpload"
                    type="file"
                    accept="image/jpeg,image/png*"
                    onChange={handlePinUpload}
                    hidden
                  />
                </Button>
                {/* {pdferror && <Alert severity="error">{pdferror}</Alert>} */}
              </Box>
            </Box>
            <Typography className="image-note">
              The Map Pin resolution should be 500 × 700 and should be in .png
              format.
            </Typography>

            <Box className="check-box">
              <Typography className="text-style">
                <b> Active/Disable</b>
              </Typography>

              <Box
                onClick={handleActive}
                sx={{ padding: "15px" }}
                className="status-wrapper"
              >
                <Box
                  onChange={handleActive}
                  className={`status-toggle1 ${
                    isChecked ? "active" : "Disable"
                  }`}
                >
                  <Box className="status-circle" />
                </Box>

                <Typography
                  sx={{ width: "30px" }}
                  className="active-txt"
                  component="span"
                >
                  {isChecked ? "Active" : "Disable"}
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* 2nd Box */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-around !important",
            }}
          >
            <Box sx={{ paddingRight: "5px" }} className="thumbnail-frame">
              {selectedImages.length > 0 ? (
                <img
                  loading="lazy"
                  src={thumbnailpreview}
                  alt="Icon"
                  width={206}
                  height={206}
                />
              ) : IconPath ? (
                <img
                  loading="lazy"
                  // loading="lazy"
                  src={`${appConfig.serviceUrls.commonURL}${IconPath}`}
                  alt=" Icon"
                  width={206}
                  height={206}
                />
              ) : (
                <Typography>Icon Preview</Typography>
              )}
            </Box>
            {/* pinIcon */}
            <Box className="thumbnail-frame">
              {selectedPin.length > 0 ? (
                <img
                  loading="lazy"
                  src={pinpreview}
                  alt="Icon"
                  width={206}
                  height={206}
                />
              ) : pinIconPath ? (
                <img
                  loading="lazy"
                  src={`${appConfig.serviceUrls.commonURL}${pinIconPath}`}
                  alt="Pin Icon"
                  width={206}
                  height={206}
                />
              ) : (
                <Typography>PinIcon Preview</Typography>
              )}
            </Box>
          </Box>
        </Box>
      )}

      {/* Action button ////////////////////////// */}
      <Stack
        className="action-button"
        direction="row"
        spacing={2}
        justifyContent="flex-end"
      >
        {/* <Button onClick={() => handleClear()} className="clear-button1">
          Clear
        </Button> */}

        <Button onClick={handleCancel} className="cancel-button">
          Cancel
        </Button>
        <Button
          //   disabled={error != null || viderror != null}
          onClick={handleSave}
          className="save-button"
        >
          {editingIndex !== null ? "Update" : "Save"}{" "}
        </Button>
      </Stack>
    </Dialog>
  );
};

export default PublishCategoryFormDialog;
